import { useAtom } from "jotai";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { canSwitchAtom } from "../atoms";

const useFormDirtyHook = (): {
  isFormDirty: boolean;
  setDirty: () => void | Promise<void>;
  setClean: () => void | Promise<void>;
} => {
  const { pathname } = useLocation();
  const [isFormDirty, setter] = useAtom(canSwitchAtom);
  const setDirty = () => setter(false);
  const setClean = () => setter(true);

  useEffect(() => {
    isFormDirty && setClean();
  }, [pathname]);

  return { isFormDirty, setDirty, setClean };
};

export default useFormDirtyHook;
